function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#484848",
  d: "M18.681 11.69c0 2.059.918 4.341 2.058 6.029.161.323.175.707-.023 1.004a1.077 1.077 0 0 1-.879.482h-4.206C15.399 20.795 14.065 22 12.437 22s-2.962-1.205-3.194-2.795H5.036c-.369 0-.676-.18-.878-.482a.94.94 0 0 1-.007-1.032c1.151-1.88 1.978-3.972 1.978-6 0-3.745.945-5.916 3.724-6.74C10.087 3.828 11.148 3 12.405 3c1.257 0 2.318.828 2.552 1.951 2.784.824 3.724 2.978 3.724 6.74z"
}), /*#__PURE__*/React.createElement("path", {
  className: "path-white",
  fill: "#FFF",
  d: "M12.501 20c.7 0 1.317-.431 1.499-1h-3c.178.577.79 1 1.501 1zM12.384 4.06c-.296 0-.57.29-.784.763.241-.053.5-.078.784-.078.275 0 .521.036.802.116-.217-.495-.498-.8-.802-.8z"
}));

var SvgBell = function SvgBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell.3117bf24.svg";
export { ForwardRef as ReactComponent };